import { PROD_TSA_APP_ID, QA_TSA_APP_ID } from '@/constants/app';

const checkIfTSAAppIsInstalled = async () => {
  let isTSAAppInstalled = false;
  if (
    'getInstalledRelatedApps' in navigator &&
    typeof navigator.getInstalledRelatedApps === 'function'
  ) {
    const relatedApps = await navigator.getInstalledRelatedApps();
    relatedApps.forEach(({ id }: any) => {
      if (id === QA_TSA_APP_ID || id === PROD_TSA_APP_ID) {
        isTSAAppInstalled = true;
      }
    });
  } else {
    console.log('getInstalledRelatedApps is not supported on this browser.');
  }
  return isTSAAppInstalled;
};

export default checkIfTSAAppIsInstalled;
